import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ContentCard from "../../common/template/contentCard";
import ContentCardHeader from "../../common/template/contentCardHeader";
import ContentCardBody from "../../common/template/contentCardBody";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { setError, setInfo } from "../../common/toast/toast.jsx";
import {
    getListaGraficoCustoDemandaEnergiaConsumida,
    getListaGraficoConsumoForaPonta,
    getListaGraficoConsumoPonta,
    getListaGraficoConsumoPorHorarioMensal,
    getListaGraficoConsumoPorHorarioAnual,
    getListaGraficoCustoPorHorarioAnual,
    getListaGraficoConsumoReservado,
    getListaGeracaoComparativoConsumo,
    setFiltro,
} from "../analiseActions";
import { montarGraficoPieAnual } from "../../common/graficos/montarGraficoPieAnual.js";
import { montarGraficoClusteredColumnMensal } from "../../common/graficos/montarGraficoClusteredColumnMensal.js";
import { montarGraficoGroupColumn } from "../../common/graficos/montarGraficoGroupColumn.js";
import { montarGraficoClusteredColumnMensalSafra } from "../../common/graficos/montarGraficoClusteredColumnMensalSafra.js";
import * as am4core from "@amcharts/amcharts4/core";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";
import Table from "../../common/table/table.jsx";
import THead from "../../common/table/tHead.jsx";
import Tr from "../../common/table/tr.jsx";
import Th from "../../common/table/th.jsx";
import TBody from "../../common/table/tBody.jsx";
import Td from "../../common/table/td.jsx";
import delta from "../../assets/images/delta.png";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import { gerarRelatorio } from "../../fatura/faturaActions.js";
import { Loading } from "../../common/loading/loading.jsx";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";

function analiseAproveitamentoConsumoHorario(props) {
    if (!props.visible) return null;
    const {
        state,
        filtro,
        setAguardando,
        listar,
        buscarPropriedadeUcFiltrada,
        listaUnidadeConsumidora,
        listaGraficoCustoDemandaEnergiaConsumida,
        listaGraficoConsumoReservado,
        listaGraficoConsumoForaPonta,
        listaGraficoConsumoPonta,
        listaGraficoConsumoHorarioMensal,
        listaGraficoCustoHorarioAnual,
        listaGraficoConsumoHorarioAnual,
        listaConsumoPercentualPorHorarioComparativoPeriodo,
        getListaGraficoCustoDemandaEnergiaConsumida,
        getListaGraficoConsumoReservado,
        getListaGraficoConsumoPonta,
        getListaGraficoConsumoPorHorarioMensal,
        getListaGraficoConsumoPorHorarioAnual,
        getListaGraficoCustoPorHorarioAnual,
        getListaGraficoConsumoForaPonta,
        getListaGeracaoComparativoConsumo,
        gerarRelatorio,
        setFiltro,
    } = props;

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [graficoCustoHorarioAnual, setGraficoCustoHorarioAnual] = useState(null);
    const [graficoConsumoHorarioAnual, setGraficoConsumoHorarioAnual] = useState(null);
    const [graficoConsumoHorarioMensal, setGraficoConsumoHorarioMensal] = useState(null);
    const [graficoConsumoPontaMensal, setGraficoConsumoPontaMensal] = useState(null);
    const [graficoConsumoForaPontaMensal, setGraficoConsumoForaPontaMensal] = useState(null);
    const [graficoConsumoReservadoMensal, setGraficoConsumoReservadoMensal] = useState(null);
    const [graficoCustoDemandaEnergiaConsumidaAnual, setGraficoCustoDemandaEnergiaConsumidaAnual] = useState(null);

    useEffect(() => {
        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;

            await Promise.all([
                getListaGraficoCustoPorHorarioAnual(),
                getListaGraficoConsumoPorHorarioAnual(),
                getListaGraficoConsumoPorHorarioMensal(),
                getListaGraficoConsumoPonta(),
                getListaGraficoConsumoForaPonta(),
                getListaGraficoConsumoReservado(),
                getListaGraficoCustoDemandaEnergiaConsumida(),
                getListaGeracaoComparativoConsumo(),
            ]);

            setAguardando(false);
        };

        buscarDados();
        if (!state.aguardando) {
            atualizarTodosGraficos();
        }
    }, [state.aguardando]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoCustoPorHorarioAnual();
        atualizarListaGraficoConsumoPorHorarioAnual();
        atualizarListaGraficoConsumoPorHorarioMensal();
        atualizarListaGraficoConsumoPonta();
        atualizarListaGraficoConsumoForaPonta();
        atualizarListaGraficoConsumoReservado();
        atualizarListaGraficoCustoDemandaEnergiaConsumida();
    }

    function desmontarTodosGraficos() {
        if (graficoCustoHorarioAnual) graficoCustoHorarioAnual.dispose();
        if (graficoConsumoHorarioAnual) graficoConsumoHorarioAnual.dispose();
        if (graficoConsumoHorarioMensal) graficoConsumoHorarioMensal.dispose();
        if (graficoConsumoPontaMensal) graficoConsumoPontaMensal.dispose();
        if (graficoConsumoForaPontaMensal) graficoConsumoForaPontaMensal.dispose();
        if (graficoConsumoReservadoMensal) graficoConsumoReservadoMensal.dispose();
        if (graficoCustoDemandaEnergiaConsumidaAnual) graficoCustoDemandaEnergiaConsumidaAnual.dispose();
    }
    function mapearListaGraficoColunasAgrupadas(lista) {
        const listaMapeada = [];
        const nomeColuna = filtro.horario_ano_safra ? "ano_inicio_fim_safra" : "ano";
        const anos = [];

        try {
            //monta uma lista com todos os anos existentes em todos meses
            for (const registro of lista) {
                const listaAnoValor = registro.itens.filter((item) => item[nomeColuna]); //remove registro com ano nulo
                for (const item of listaAnoValor) {
                    const ano = item[nomeColuna];
                    if (!anos.includes(ano)) {
                        anos.push(ano);
                    }
                }
            }
            anos.sort((a, b) => {
                return filtro.horario_ano_safra ? parseInt(a.split("/")[0]) - parseInt(b.split("/")[0]) : parseInt(a) - parseInt(b);
            });
            //percorre todos os meses
            for (const registro of lista) {
                //se encontrar o ano do mes na lista de anos, pega o respectivo valor, senao define o valor zero para o ano
                const colunas = { mes: registro.mes };
                for (const ano of anos) {
                    const anoExisteNoMes = registro.itens.find((item) => item[nomeColuna] == ano);
                    if (anoExisteNoMes && parseFloat(anoExisteNoMes.valor)) {
                        colunas[ano] = parseFloat(anoExisteNoMes.valor);
                    } else {
                        colunas[ano] = 0;
                    }
                }
                listaMapeada.push(colunas);
            }
            return {
                dados: listaMapeada,
                valuesAndNames: anos.map((item) => ({ value: item, name: item })),
            };
        } catch (erro) {
            console.log(erro);
            setError("Erro ao gerar gráficos de consumo por horário");
            return {
                dados: [],
                valuesAndNames: [],
            };
        }
    }

    function atualizarListaGraficoCustoPorHorarioAnual() {
        const graficoCustoHorarioAnualAtualizado = montarGraficoPieAnual(
            state,
            graficoCustoHorarioAnual,
            "graficoCustoHorarioAnual",
            listaGraficoCustoHorarioAnual,
            "Custo Total por Horário (R$)",
            "R$",
            ""
        );
        setGraficoCustoHorarioAnual(graficoCustoHorarioAnualAtualizado);
    }

    function atualizarListaGraficoConsumoPorHorarioAnual() {
        const graficoConsumoHorarioAnualAtualizado = montarGraficoPieAnual(
            state,
            graficoConsumoHorarioAnual,
            "graficoConsumoHorarioAnual",
            listaGraficoConsumoHorarioAnual,
            "Consumo Total por Horário (kWh)",
            "",
            "kWh"
        );
        setGraficoConsumoHorarioAnual(graficoConsumoHorarioAnualAtualizado);
    }

    function atualizarListaGraficoConsumoPorHorarioMensal() {
        const funcaoMontarGrafico = filtro.horario_ano_safra ? montarGraficoClusteredColumnMensalSafra : montarGraficoClusteredColumnMensal;
        const graficoConsumoHorarioMensalAtualizado = funcaoMontarGrafico({
            state: state,
            component: graficoConsumoHorarioMensal,
            nome: "graficoConsumoHorarioMensal",
            dados: listaGraficoConsumoHorarioMensal.map((item) => ({
                mes: item.mes,
                anos: item.tipos.map((tipo) => ({
                    ano: tipo.tipo,
                    valor: tipo.valor,
                })),
            })),
            titulo: "Consumo Mensal por Horário (kWh)",
            prefixo: "",
            sufixo: "kWh",
        });
        setGraficoConsumoHorarioMensal(graficoConsumoHorarioMensalAtualizado);
    }

    function atualizarListaGraficoConsumoPonta() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoConsumoPonta);
        const graficoConsumoPontaMensalAtualizado = montarGraficoGroupColumn({
            state,
            component: graficoConsumoPontaMensal,
            nome: "graficoConsumoPontaMensal",
            dados,
            category: "mes",
            valuesAndNames,
            titulo: "Consumo Ponta Mensal (kWh)",
            prefixo: "",
            sufixo: "kWh",
            dimensions: "3D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
        });
        setGraficoConsumoPontaMensal(graficoConsumoPontaMensalAtualizado);
    }

    function atualizarListaGraficoConsumoForaPonta() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoConsumoForaPonta);
        const graficoConsumoForaPontaMensalAtualizado = montarGraficoGroupColumn({
            state,
            component: graficoConsumoForaPontaMensal,
            nome: "graficoConsumoForaPontaMensal",
            dados,
            category: "mes",
            valuesAndNames,
            titulo: "Consumo Fora Ponta Mensal (kWh)",
            prefixo: "",
            sufixo: "kWh",
            dimensions: "3D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
        });
        setGraficoConsumoForaPontaMensal(graficoConsumoForaPontaMensalAtualizado);
    }

    function atualizarListaGraficoConsumoReservado() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoConsumoReservado);
        const graficoConsumoReservadoMensalAtualizado = montarGraficoGroupColumn({
            state,
            component: graficoConsumoReservadoMensal,
            nome: "graficoConsumoReservadoMensal",
            dados,
            category: "mes",
            valuesAndNames,
            titulo: "Consumo Reservado Mensal (kWh)",
            prefixo: "",
            sufixo: "kWh",
            dimensions: "3D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
        });
        setGraficoConsumoReservadoMensal(graficoConsumoReservadoMensalAtualizado);
    }

    function atualizarListaGraficoCustoDemandaEnergiaConsumida() {
        const creditos = { "Crédito Solar": 0, "Devoluções e Ressarcimentos": 0, "Energia Consumida (sem descontar)": 0 };
        let listaFiltrada = [...listaGraficoCustoDemandaEnergiaConsumida].map((item) => {
            const tiposFiltrados = item.tipos.filter((itemTipo) => {
                //separa esses itens para informar que foram descontados do total da Energia Consumida
                if (itemTipo.tipo === "Devoluções e Ressarcimentos" || itemTipo.tipo === "Crédito Solar") {
                    creditos[itemTipo.tipo] += parseFloat(itemTipo.valor) || 0;
                    return false;
                } else if (itemTipo.tipo === "Energia Consumida") {
                    creditos["Energia Consumida (sem descontar)"] += parseFloat(itemTipo.valor_original) || 0;
                    return true;
                } else {
                    return true;
                }
            });
            return {
                ...item,
                tipos: tiposFiltrados,
            };
        });
        if (filtro.unidades_consumidoras.length == 1) {
            const ucSelecionada = listaUnidadeConsumidora.find((uc) => uc.id == filtro.unidades_consumidoras[0].value);

            const grupoA = [1, 4].includes(parseInt(ucSelecionada.id_grupo_faturamento));
            const modalidadeTarifariaVerde = ucSelecionada.id_modalidade_tarifaria == 1;
            const modalidadeTarifariaAzul = ucSelecionada.id_modalidade_tarifaria == 2;
            const geradora = ucSelecionada.geracao;

            listaFiltrada = listaFiltrada.map((item) => {
                const tiposFiltrados = item.tipos.filter((itemTipo) => {
                    if (grupoA && modalidadeTarifariaVerde && !geradora) {
                        // Unidade Grupo A Verde sem Geraçao: Demanda Fora ponta
                        return !itemTipo.tipo.includes("Demanda") || itemTipo.tipo === "Demanda Fora Ponta";
                    } else if (grupoA && modalidadeTarifariaAzul && !geradora) {
                        // Unidade Grupo A azul Sem Geraçao: Demanda fora Ponta e demanda Ponta
                        return !itemTipo.tipo.includes("Demanda") || itemTipo.tipo.includes("Ponta");
                    } else if (grupoA && modalidadeTarifariaVerde && geradora) {
                        // Unidade Grupo A Verde com Geraçao: Demanda Fora ponta e Demanda Geraçao
                        return !itemTipo.tipo.includes("Demanda") || itemTipo.tipo === "Demanda Fora Ponta" || itemTipo.tipo === "Demanda de Geração";
                    } else if (grupoA && modalidadeTarifariaAzul && geradora) {
                        // Unidade Grupo A azul com Geraçao: Demanda fora Ponta e demanda Ponta e Demanda Geraçao
                        return true; //retorna todos tipos
                    } else {
                        return true; //retorna todos tipos
                    }
                });
                return {
                    ...item,
                    tipos: tiposFiltrados,
                };
            });
        }

        const cores = {
            "Energia Consumida": am4core.color("#0bbd4f"),
            "Demanda Ponta": am4core.color("#f2ff40"),
            "Demanda Fora Ponta": am4core.color("#3357FF"),
            "Demanda de Geração": am4core.color("#ff8838"),
            "Demais Custos": am4core.color("#e43d3d"),
            Bandeiras: am4core.color("#5afd78"),
        };

        const msgValorOriginal = ` R$ ${adicionarPontosMilhar(creditos["Energia Consumida (sem descontar)"])}`;
        const msgCreditos = creditos["Crédito Solar"] ? ` - R$ ${adicionarPontosMilhar(creditos["Crédito Solar"])} (Crédito Solar)` : "";
        const msgDevolucoes = creditos["Devoluções e Ressarcimentos"]
            ? ` - R$ ${adicionarPontosMilhar(creditos["Devoluções e Ressarcimentos"])} (Devoluções e Ressarcimentos)`
            : "";

        const existeDescontos = msgCreditos || msgDevolucoes;
        const graficoCustoDemandaEnergiaConsumidaAnualAtualizado = montarGraficoPieAnual(
            state,
            graficoCustoDemandaEnergiaConsumidaAnual,
            "graficoCustoDemandaEnergiaConsumidaAnual",
            listaFiltrada,
            "Demanda X Energia Consumida (R$)",
            "R$",
            "",
            true, //ocultarLegenda
            85,
            cores,
            { "Energia Consumida": existeDescontos ? `\n Cálculo: ${msgValorOriginal}${msgCreditos}${msgDevolucoes}` : "" } //sufixo para tipo específico, para exibir o cálculo
        );
        setGraficoCustoDemandaEnergiaConsumidaAnual(graficoCustoDemandaEnergiaConsumidaAnualAtualizado);
    }

    const totaisTabelaHorariosComparativoPeriodo = {
        irrigantes_consumo_total_a: 0,
        irrigantes_consumo_ponta_a: 0,
        irrigantes_consumo_fora_ponta_a: 0,
        irrigantes_consumo_reservado_a: 0,
        irrigantes_consumo_total_b: 0,
        irrigantes_consumo_ponta_b: 0,
        irrigantes_consumo_fora_ponta_b: 0,
        irrigantes_consumo_reservado_b: 0,
        irrigantes_retorno_financeiro_ponta: 0,
        irrigantes_retorno_financeiro_reservado: 0,
        nao_irrigantes_consumo_total_a: 0,
        nao_irrigantes_consumo_ponta_a: 0,
        nao_irrigantes_consumo_fora_ponta_a: 0,
        nao_irrigantes_consumo_reservado_a: 0,
        nao_irrigantes_consumo_total_b: 0,
        nao_irrigantes_consumo_ponta_b: 0,
        nao_irrigantes_consumo_fora_ponta_b: 0,
        nao_irrigantes_consumo_reservado_b: 0,
        nao_irrigantes_retorno_financeiro_ponta: 0,
        nao_irrigantes_retorno_financeiro_reservado: 0,
    };

    function bloquearScroll(e) {
        e.preventDefault();
    }

    function toggleScroll(bloquear) {
        if (bloquear) {
            document.body.style.overflowY = "hidden";
            window.addEventListener("wheel", bloquearScroll, { passive: false });
            window.addEventListener("touchmove", bloquearScroll, { passive: false });
        } else {
            document.body.style.overflowY = "auto";
            window.removeEventListener("wheel", bloquearScroll);
            window.removeEventListener("touchmove", bloquearScroll);
        }
    }

    async function handleExport({ graficosAtivos, quantidadeUCs }) {
        const ALTURA_MAX_CONTEUDO = 84;
        const condicaoGraficoPaginaInteira = quantidadeUCs > 15;
        const condicao3PorPagina = quantidadeUCs <= 5;
        const graficosPorPaginaEmFuncaoDeQuantidadeUCs = condicaoGraficoPaginaInteira ? 1 : condicao3PorPagina ? 3 : 2;
        const graficosPizza = [graficoCustoHorarioAnual, graficoConsumoHorarioAnual, graficoCustoDemandaEnergiaConsumidaAnual].filter(Boolean);

        const definirRaioPizzaExportacao = (raio) => {
            graficosPizza.forEach((grafico) => {
                grafico.radius = am4core.percent(raio);
                if (grafico.invalidateSize) {
                    grafico.invalidateSize();
                }
            });
        };

        setLoading(true);
        toggleScroll(true);
        definirRaioPizzaExportacao(125);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0, paddingLeft }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = "0.80"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1200 - desconto + "px";
            } else {
                const tamanhoGrafico = (window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto;
                el.style.width = `${tamanhoGrafico}px`;
                el.style.paddingLeft = paddingLeft || "0px";
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const calcularWidthTabela = ({ el, zoom = 1, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.zoom = "0.7" * (zoom / 1); // ajusta de verdade o tamanho do elemento
                el.style.width = 1500 - desconto + "px";
            } else {
                el.style.zoom = 1 * (zoom / 1);
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarGrafico = ({ el, paddingLeft, height }) => {
            if (el) {
                el.style.marginTop = "0px";
                el.style.fontSize = "0.8rem";
                if(height){
                    el.style.height = height
                }
                calcularWidthGrafico({ el, paddingLeft });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
                const titulo = el.querySelectorAll("tspan");
                titulo.forEach((el) => {
                    if (el.textContent.includes("(kWh)") || el.textContent.includes("(R$)")) {
                        const text = el.closest("text");

                        if (text) {
                            text.style.overflow = "visible";
                            text.setAttribute("textLength", String(el.textContent.length * 9));
                            text.setAttribute("lengthAdjust", "spacing");
                        }

                        el.setAttribute("dx", "-35");
                        el.style.fontSize = "1.15rem";
                        el.style.fontWeight = "bold";
                    }
                });
            }
        };
        const formatarTabela = ({ el, zoom, heightCelula }) => {
            if (el) {
                calcularWidthTabela({ el, zoom });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula) => {
                    if (heightCelula) {
                        celula.style.height = heightCelula;
                    }
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = "left";

                    // Remove botões dentro do próprio td (fora da div filha)
                    celula.querySelectorAll("button").forEach((btn) => btn.remove());
                });
            }
        };
        const exibirTagOculta = ({ el, textAlign = "left", backgroundColor, titulo = false }) => {
            if (el) {
                calcularWidthGrafico({ el, desconto: 20 });
                el.style.color = "#FFFFFF";
                el.style.fontSize = titulo ? "1.6rem" : "1rem";
                el.style.lineHeight = "1rem";
                el.style.fontWeight = "bold";
                el.style.backgroundColor = backgroundColor || "#30303d";
                el.style.visibility = "visible";
                el.style.marginBottom = "0px";
                el.style.marginTop = "10px";
                el.style.padding = "5px";
                el.style.textAlign = textAlign;
            }
        };

        function calcularAlturaGraficosUC({ condicaoUltrapassaPaginas, quantidadeUCs, quantidadeLimite }) {
            const paginasOcupadasMesmoGrafico = Math.ceil(quantidadeUCs / quantidadeLimite);

            let alturaGraficosUC = ALTURA_MAX_CONTEUDO / graficosPorPaginaEmFuncaoDeQuantidadeUCs;

            if (condicaoUltrapassaPaginas) {
                let total = 0;

                for (let i = 0; i < paginasOcupadasMesmoGrafico; i++) {
                    //na primeira pagina soma mais 4% pra compensar a falta do rodapé
                    if (i == 0) {
                        total += ALTURA_MAX_CONTEUDO + 4;
                    } else if (i > 0 && i < paginasOcupadasMesmoGrafico - 1) {
                        //se é pagina do meia conta 100%, pq não tem cabeçalho nem rodapé
                        total += ALTURA_MAX_CONTEUDO + 16;
                    } else if (i == paginasOcupadasMesmoGrafico - 1) {
                        //na última pagina soma mais 10% pra compensar a falta do cabeçalho
                        total += ALTURA_MAX_CONTEUDO + 10;
                    }
                }

                alturaGraficosUC = total;
            }

            return alturaGraficosUC;
        }

        if (contentCardRef.current) {
            const alinhamentoVertical = quantidadeUCs > 10 ? "flex-start" : "center";

            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            const periodoGraficosPizza = contentCardRef.current.querySelector("#periodoGraficosPizza");
            const graficoCustoHorarioAnual = contentCardRef.current.querySelector("#graficoCustoHorarioAnual");
            const graficoConsumoHorarioAnual = contentCardRef.current.querySelector("#graficoConsumoHorarioAnual");
            const graficoCustoDemandaEnergiaConsumidaAnual = contentCardRef.current.querySelector("#graficoCustoDemandaEnergiaConsumidaAnual");

            const graficoConsumoHorarioMensal = contentCardRef.current.querySelector("#graficoConsumoHorarioMensal");
            const graficoConsumoPontaMensal = contentCardRef.current.querySelector("#graficoConsumoPontaMensal");
            const tabelaGraficoConsumoPontaMensal = contentCardRef.current.querySelector("#tabelaGraficoConsumoPontaMensal");
            const graficoConsumoForaPontaMensal = contentCardRef.current.querySelector("#graficoConsumoForaPontaMensal");
            const tabelaGraficoConsumoForaPontaMensal = contentCardRef.current.querySelector("#tabelaGraficoConsumoForaPontaMensal");
            const graficoConsumoReservadoMensal = contentCardRef.current.querySelector("#graficoConsumoReservadoMensal");
            const tabelaGraficoConsumoReservadoMensal = contentCardRef.current.querySelector("#tabelaGraficoConsumoReservadoMensal");
            const tabelaHorarioComparativoPeriodo = contentCardRef.current.querySelector("#tabelaHorarioComparativoPeriodo");
            const periodoA = contentCardRef.current.querySelector("#periodoA");
            const periodoB = contentCardRef.current.querySelector("#periodoB");

            const qtdLinhasTabela = 21;

            // tituloGraficoGeracaoAvaliacaoProducaoMensal
            exibirTagOculta({ el: periodoGraficosPizza, textAlign: "center", titulo: true});
            formatarGrafico({ el: graficoCustoHorarioAnual, paddingLeft: "100px", height: 600});
            formatarGrafico({ el: graficoConsumoHorarioAnual,  paddingLeft: "50px", height: 600 });
            formatarGrafico({ el: graficoCustoDemandaEnergiaConsumidaAnual, paddingLeft: "50px", height: 600 });

            formatarGrafico({ el: graficoConsumoHorarioMensal });
            formatarGrafico({ el: graficoConsumoPontaMensal });
            formatarTabela({ el: tabelaGraficoConsumoPontaMensal });
            formatarGrafico({ el: graficoConsumoForaPontaMensal });
            formatarTabela({ el: tabelaGraficoConsumoForaPontaMensal });
            formatarGrafico({ el: graficoConsumoReservadoMensal });
            formatarTabela({ el: tabelaGraficoConsumoReservadoMensal });
            formatarTabela({ el: tabelaHorarioComparativoPeriodo, zoom: 0.75 });
            exibirTagOculta({ el: periodoA, backgroundColor: "#252530" });
            exibirTagOculta({ el: periodoB, backgroundColor: "#252530" });

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; max-height:fit-content;font-family: Arial, sans-serif;"><div style="width:100%; height:10%;">
                                               <img src="${base64Cabecalho}" width="100%" />
                                           </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                                       <img src="${base64Rodape}" width="100%" />
                                                   </div>
                                               </div> `;

            // Captura o HTML com os estilos atualizados
            const htmlGraficosPizza =
                graficosAtivos.includes("graficosPizza") && graficoCustoHorarioAnual && graficoConsumoHorarioAnual && graficoCustoDemandaEnergiaConsumidaAnual
                    ? `<div style="width:100%; height:28%; margin-bottom:10px; background-color:#30303d">` +
                      `<div style="display:flex; flex-direction:row; align-items:center; height:10%; justify-content:center;">${periodoGraficosPizza.outerHTML}</div>` +
                      `<div style="display:flex; flex-direction:row; align-items:center; height:90%; justify-content:center;">${
                          graficoCustoHorarioAnual.outerHTML + graficoConsumoHorarioAnual.outerHTML + graficoCustoDemandaEnergiaConsumidaAnual.outerHTML
                      }</div>` +
                      "</div>"
                    : "";

            const htmlGraficoConsumoHorarioMensal =
                graficosAtivos.includes("graficoConsumoHorarioMensal") && graficoConsumoHorarioMensal
                    ? `<div style="display:flex; flex-direction:column; align-items:center; justify-content:center; width:100%; height:28%; margin-bottom:10px; background-color:#30303d">${graficoConsumoHorarioMensal.outerHTML}</div>`
                    : "";
            const htmlGraficoConsumoPontaMensal =
                graficosAtivos.includes("graficoConsumoPontaMensal") && graficoConsumoPontaMensal
                    ? `<div style="display:flex; flex-direction:column; align-items:center; justify-content:center; width:100%; height:28%; margin-bottom:10px; background-color:#30303d">${
                          graficoConsumoPontaMensal.outerHTML + tabelaGraficoConsumoPontaMensal.outerHTML
                      }</div>`
                    : "";
            const htmlGraficoConsumoForaPontaMensal =
                graficosAtivos.includes("graficoConsumoForaPontaMensal") && graficoConsumoForaPontaMensal
                    ? `<div style="display:flex; flex-direction:column; align-items:center; justify-content:center; width:100%; height:28%; margin-bottom:10px; background-color:#30303d">${
                          graficoConsumoForaPontaMensal.outerHTML + tabelaGraficoConsumoForaPontaMensal.outerHTML
                      }</div>`
                    : "";
            const htmlGraficoConsumoReservadoMensal =
                graficosAtivos.includes("graficoConsumoReservadoMensal") && graficoConsumoReservadoMensal
                    ? `<div style="display:flex; flex-direction:column; align-items:center; justify-content:center; width:100%; height:28%; margin-bottom:10px; background-color:#30303d">${
                          graficoConsumoReservadoMensal.outerHTML + tabelaGraficoConsumoReservadoMensal.outerHTML
                      }</div>`
                    : "";
            const htmlTabelaHorarioComparativoPeriodo =
                graficosAtivos.includes("tabelaHorarioComparativoPeriodo") && tabelaHorarioComparativoPeriodo
                    ? `<div style="display:flex; flex-direction:column; align-items:center; justify-content:justify-content:${alinhamentoVertical}; width:100%; height:${calcularAlturaGraficosUC(
                          {
                              condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                              quantidadeUCs,
                              quantidadeLimite: qtdLinhasTabela,
                          }
                      )}%; margin-bottom:10px; background-color:#30303d">${tabelaHorarioComparativoPeriodo.outerHTML}</div>`
                    : "";

            const graficos = [
                { h: 28, el: htmlGraficosPizza },
                { h: 28, el: htmlGraficoConsumoHorarioMensal },
                { h: 28, el: htmlGraficoConsumoPontaMensal },
                { h: 28, el: htmlGraficoConsumoForaPontaMensal },
                { h: 28, el: htmlGraficoConsumoReservadoMensal },
                {
                    h: calcularAlturaGraficosUC({
                        condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                        quantidadeUCs,
                        quantidadeLimite: qtdLinhasTabela,
                    }),
                    el: htmlTabelaHorarioComparativoPeriodo,
                },
            ].filter((g) => g.el);

            if (!graficos.length) {
                setLoading(false);
                toggleScroll(false);
                return;
            }

            const listaPaginas = [];
            for (const g of graficos) {
                if (!listaPaginas.length) {
                    listaPaginas.push({
                        indice: listaPaginas.length,
                        alturaAcumulada: g.h,
                        graficos: [g.el],
                    });
                } else {
                    const ultimaPaginaIncluida = listaPaginas[listaPaginas.length - 1];
                    if (ultimaPaginaIncluida.alturaAcumulada + g.h > ALTURA_MAX_CONTEUDO) {
                        listaPaginas.push({
                            indice: listaPaginas.length,
                            alturaAcumulada: g.h,
                            graficos: [g.el],
                        });
                    } else {
                        ultimaPaginaIncluida.alturaAcumulada += g.h;
                        ultimaPaginaIncluida.graficos.push(g.el);
                    }
                }
            }

            let html = "";

            listaPaginas.forEach((pagina) => {
                html += htmlCabecalho;
                pagina.graficos.forEach((grafico) => {
                    html += grafico;
                });
                if (pagina.alturaAcumulada < ALTURA_MAX_CONTEUDO) {
                    html += `<div style="width:100%; height:${ALTURA_MAX_CONTEUDO - pagina.alturaAcumulada}%"></div>`;
                }
                html += htmlRodape;
            });
            // Gera o relatório com o HTML atualizado
            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            toggleScroll(false);
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    const quantidadeUCs = listaConsumoPercentualPorHorarioComparativoPeriodo.length || 0;

    const anosListaPonta = listaGraficoConsumoPonta.reduce((acc, item) => {
        for (const itemAno of item.itens.sort((a, b) => a.ano - b.ano)) {
            if (!acc.includes(itemAno.ano)) {
                acc.push(itemAno.ano);
            }
        }
        return acc;
    }, []);

    const anosListaForaPonta = listaGraficoConsumoForaPonta.reduce((acc, item) => {
        for (const itemAno of item.itens.sort((a, b) => a.ano - b.ano)) {
            if (!acc.includes(itemAno.ano)) {
                acc.push(itemAno.ano);
            }
        }
        return acc;
    }, []);

    const anosListaReservado = listaGraficoConsumoReservado.reduce((acc, item) => {
        for (const itemAno of item.itens.sort((a, b) => a.ano - b.ano)) {
            if (!acc.includes(itemAno.ano)) {
                acc.push(itemAno.ano);
            }
        }
        return acc;
    }, []);

    return (
        <div ref={contentCardRef}>
            {loading ? (
                <>
                    <Loading />
                    <div style={{ height: "100vh", width: "100%" }}></div>
                </>
            ) : null}
            <ContentCard
                style={{
                    color: "#fff",
                    padding: 8,
                }}
            >
                <ContentCardHeader style={{ backgroundColor: "#fff" }}>
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"dark"}
                                icon={"fa fa-file-export"}
                                event={() => {
                                    if (!filtro.id_cliente) {
                                        return setInfo("Selecione um cliente e clique em atualizar antes de exportar");
                                    }
                                    setModalExportacaoAberto(true);
                                }}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)} visibility={loading ? "hidden" : "visible"}>
                            <ExportAnalise
                                quantidadeUCs={quantidadeUCs}
                                listaGraficosDisponiveis={[
                                    "graficosPizza",
                                    "graficoConsumoHorarioMensal",
                                    "graficoConsumoPontaMensal",
                                    "graficoConsumoForaPontaMensal",
                                    !buscarPropriedadeUcFiltrada() || buscarPropriedadeUcFiltrada("irrigante") ? "graficoConsumoReservadoMensal" : null,
                                    "tabelaHorarioComparativoPeriodo",
                                ]}
                            />
                        </ModalAlert>
                    ) : null}
                    <Row>
                        <Grid cols="6 4 3 2">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                <DatePicker
                                    variant="inline"
                                    openTo="year"
                                    views={["year", "month"]}
                                    label="De"
                                    autoOk
                                    value={
                                        filtro.competencia_inicial_horario
                                            ? `${String(filtro.competencia_inicial_horario).substring(0, 4)}/${String(filtro.competencia_inicial_horario).substring(
                                                  4,
                                                  6
                                              )}/01 12:00:00`
                                            : null
                                    }
                                    onChange={(value) => {
                                        setFiltro({
                                            ...filtro,
                                            competencia_inicial_horario: value ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`) : null,
                                        });
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid cols="6 4 3 2">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                <DatePicker
                                    variant="inline"
                                    openTo="year"
                                    views={["year", "month"]}
                                    label="Até"
                                    autoOk
                                    value={
                                        filtro.competencia_final_horario
                                            ? `${String(filtro.competencia_final_horario).substring(0, 4)}/${String(filtro.competencia_final_horario).substring(4, 6)}/01 12:00:00`
                                            : null
                                    }
                                    onChange={(value) => {
                                        setFiltro({
                                            ...filtro,
                                            competencia_final_horario: value ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`) : null,
                                        });
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid cols="12 4 3 2" style={{ paddingTop: 10 }}>
                            <Button
                                text="Limpar Período"
                                type={"primary"}
                                icon={"fa fa-minus"}
                                event={() => {
                                    setFiltro({
                                        ...filtro,
                                        competencia_inicial_horario: null,
                                        competencia_final_horario: null,
                                    });
                                }}
                            />
                        </Grid>
                        <Grid cols="6 4 3 2" style={{ paddingTop: 10 }}>
                            <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={listar} />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="graficosPizza">
                        <Row>
                            <div id="periodoGraficosPizza" style={{ visibility: "hidden", marginBottom: 10 }}>{`De ${
                                filtro.competencia_inicial_horario
                                    ? `${String(filtro.competencia_inicial_horario).substring(4, 6)}/${String(filtro.competencia_inicial_horario).substring(0, 4)}`
                                    : null
                            } até ${
                                filtro.competencia_final_horario
                                    ? `${String(filtro.competencia_final_horario).substring(4, 6)}/${String(filtro.competencia_final_horario).substring(0, 4)}`
                                    : null
                            }`}</div>
                        </Row>
                        <Row>
                            <Grid cols="12 4 4 4" style={{ display: "flex" }}>
                                <div id="graficoCustoHorarioAnual" style={{ width: "100%", paddingBlock: 20, height: 400}}></div>
                            </Grid>
                            <Grid cols="12 4 4 4" style={{ display: "flex" }}>
                                <div id="graficoConsumoHorarioAnual" style={{ width: "100%", paddingBlock: 20, height: 400 }}></div>
                            </Grid>
                            <Grid cols="12 4 4 4" style={{ display: "flex" }}>
                                <div id="graficoCustoDemandaEnergiaConsumidaAnual" style={{ width: "100%", paddingBlock: 20, height: 400 }}></div>
                            </Grid>
                        </Row>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="graficoConsumoHorarioMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="graficoConsumoPontaMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                    <Table id="tabelaGraficoConsumoPontaMensal" responsive>
                        <TBody>
                            {anosListaPonta.map((ano) => (
                                <Tr key={ano}>
                                    <Td>{ano}</Td>
                                    {listaGraficoConsumoPonta.map((item) => {
                                        const valor = (item.itens.find((itemAno) => itemAno.ano == ano) || {}).valor;
                                        return (
                                            <Td key={item.mes} alignCenter>
                                                {valor ? adicionarPontosMilhar(valor) + " kWh" : " - "}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="graficoConsumoForaPontaMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                    <Table id="tabelaGraficoConsumoForaPontaMensal" responsive>
                        <TBody>
                            {anosListaForaPonta.map((ano) => (
                                <Tr key={ano}>
                                    <Td>{ano}</Td>
                                    {listaGraficoConsumoForaPonta.map((item) => {
                                        const valor = (item.itens.find((itemAno) => itemAno.ano == ano) || {}).valor;
                                        return (
                                            <Td key={item.mes} alignCenter>
                                                {valor ? adicionarPontosMilhar(valor) + " kWh" : " - "}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
            <ContentCard
                style={{
                    color: "#fff",
                    padding: 8,
                    display: !buscarPropriedadeUcFiltrada() || buscarPropriedadeUcFiltrada("irrigante") ? "" : "none",
                }}
            >
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="graficoConsumoReservadoMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                    <Table id="tabelaGraficoConsumoReservadoMensal" responsive>
                        <TBody>
                            {anosListaReservado.map((ano) => (
                                <Tr key={ano}>
                                    <Td>{ano}</Td>
                                    {listaGraficoConsumoReservado.map((item) => {
                                        const valor = (item.itens.find((itemAno) => itemAno.ano == ano) || {}).valor;
                                        return (
                                            <Td key={item.mes} alignCenter>
                                                {valor ? adicionarPontosMilhar(valor) + " kWh" : " - "}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
            <ContentCard>
                <ContentCardHeader>
                    <div id="periodoTabelaHorariosComparativoPeriodo" style={{ visibility: "hidden", marginBottom: 10 }}></div>
                    <Row>
                        <Grid cols="12 6 5 5">
                            <Row>
                                <Grid cols="12 12 12 12">
                                    <label>Período A</label>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="De"
                                            autoOk
                                            value={
                                                filtro.competencia_inicial_horario_comparativo_antes
                                                    ? `${String(filtro.competencia_inicial_horario_comparativo_antes).substring(0, 4)}/${String(
                                                          filtro.competencia_inicial_horario_comparativo_antes
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_inicial_horario_comparativo_antes: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="Até"
                                            autoOk
                                            value={
                                                filtro.competencia_final_horario_comparativo_antes
                                                    ? `${String(filtro.competencia_final_horario_comparativo_antes).substring(0, 4)}/${String(
                                                          filtro.competencia_final_horario_comparativo_antes
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_final_horario_comparativo_antes: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Row>
                        </Grid>
                        <Grid cols="12 6 5 5">
                            <Row>
                                <Grid cols="12 12 12 12">
                                    <label>Período B</label>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="De"
                                            autoOk
                                            value={
                                                filtro.competencia_inicial_horario_comparativo_depois
                                                    ? `${String(filtro.competencia_inicial_horario_comparativo_depois).substring(0, 4)}/${String(
                                                          filtro.competencia_inicial_horario_comparativo_depois
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_inicial_horario_comparativo_depois: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="Até"
                                            autoOk
                                            value={
                                                filtro.competencia_final_horario_comparativo_depois
                                                    ? `${String(filtro.competencia_final_horario_comparativo_depois).substring(0, 4)}/${String(
                                                          filtro.competencia_final_horario_comparativo_depois
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_final_horario_comparativo_depois: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Row>
                        </Grid>

                        <Grid cols="12 12 2 2" style={{ paddingTop: 10 }}>
                            <Button
                                text="Analisar"
                                type={"primary"}
                                icon={"fa fa-sync"}
                                event={() => {
                                    getListaGeracaoComparativoConsumo();
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        color: "#fff",
                        padding: 10,
                    }}
                >
                    <p className="text-center" style={{ fontSize: 16, margin: 0 }}>
                        Aproveitamento Horário Comparativo Entre Períodos
                    </p>
                    <Row style={{ marginBottom: 20 }}>
                        <Grid
                            cols="12 12 12 12"
                            style={{
                                maxHeight: 500,
                                padding: 10,
                                overflowX: "auto",
                                overflowY: "hidden",
                            }}
                        >
                            <Table id="tabelaHorarioComparativoPeriodo" responsive maxHeight={480} minWidth={750} fontSize="0.78rem">
                                <THead>
                                    <Tr>
                                        <Th minHeight={67} sticky backgroundColor="#30303d"></Th>
                                        <Th minHeight={67} sticky colSpan={11} alignCenter backgroundColor="#252530" style={{ textWrap: "nowrap" }}>
                                            Período A
                                            <span id="periodoA" style={{ visibility: "hidden" }}>
                                                {"(De "}
                                                {filtro.competencia_inicial_horario_comparativo_antes
                                                    ? `${String(filtro.competencia_inicial_horario_comparativo_antes).substring(4, 6)}/${String(
                                                          filtro.competencia_inicial_horario_comparativo_antes
                                                      ).substring(0, 4)}`
                                                    : null}
                                                {" à "}
                                                {filtro.competencia_final_horario_comparativo_antes
                                                    ? `${String(filtro.competencia_final_horario_comparativo_antes).substring(4, 6)}/${String(
                                                          filtro.competencia_final_horario_comparativo_antes
                                                      ).substring(0, 4)}`
                                                    : null}
                                                {")"}
                                            </span>
                                        </Th>
                                        <Th minHeight={67} sticky colSpan={11} alignCenter backgroundColor="#222129" style={{ textWrap: "nowrap" }}>
                                            Período B
                                            <span id="periodoB" style={{ visibility: "hidden" }}>
                                                {"(De "}
                                                {filtro.competencia_inicial_horario_comparativo_depois
                                                    ? `${String(filtro.competencia_inicial_horario_comparativo_depois).substring(4, 6)}/${String(
                                                          filtro.competencia_inicial_horario_comparativo_depois
                                                      ).substring(0, 4)}`
                                                    : null}
                                                {" à "}
                                                {filtro.competencia_final_horario_comparativo_depois
                                                    ? `${String(filtro.competencia_final_horario_comparativo_depois).substring(4, 6)}/${String(
                                                          filtro.competencia_final_horario_comparativo_depois
                                                      ).substring(0, 4)}`
                                                    : null}
                                                {")"}
                                            </span>
                                        </Th>
                                        <Th minHeight={67} sticky colSpan={3} backgroundColor="#272739"></Th>
                                        <Th minHeight={67} sticky colSpan={3} backgroundColor="#30303d"></Th>
                                    </Tr>
                                    <Tr>
                                        <Th minHeight={67} top={42} sticky backgroundColor="#30303d"></Th>
                                        <Th minHeight={67} top={42} sticky colSpan={11} alignCenter backgroundColor="#252530" style={{ textWrap: "nowrap" }}>
                                            Perfil de Consumo <p style={{ margin: 0 }}>(Aproveitamento Horário % de kWh)</p>
                                        </Th>
                                        {/* <Th minHeight={67} sticky colSpan={3} alignCenter backgroundColor="#2c2c3d" verticalAlign="middle">
                                            Custos de Tarifas
                                        </Th> */}
                                        <Th minHeight={67} top={42} sticky colSpan={11} alignCenter backgroundColor="#222129" style={{ textWrap: "nowrap" }}>
                                            Perfil de Consumo <p style={{ margin: 0 }}>(Aproveitamento Horário % de kWh)</p>
                                        </Th>
                                        <Th minHeight={67} top={42} sticky colSpan={3} alignCenter backgroundColor="#272739" verticalAlign="middle">
                                            Custos de Tarifas{" "}
                                            {filtro.competencia_final_horario_comparativo_depois
                                                ? `(${String(filtro.competencia_final_horario_comparativo_depois).substring(4, 6)}/${String(
                                                      filtro.competencia_final_horario_comparativo_depois
                                                  ).substring(0, 4)})`
                                                : null}
                                        </Th>
                                        <Th minHeight={67} top={42} alignCenter colSpan={3} sticky backgroundColor="#30303d">
                                            Efeito de Economia
                                        </Th>
                                    </Tr>
                                    <Tr>
                                        <Th rowSpan={2} top={104} sticky backgroundColor="#30303d" style={{ verticalAlign: "middle" }}>
                                            Unidade Consumidora
                                        </Th>
                                        <Th colSpan={2} alignCenter top={104} sticky backgroundColor="#252530">
                                            Total
                                        </Th>
                                        <Th colSpan={3} top={104} minWidth={150} sticky alignCenter color="#ff6e81" backgroundColor="#252530">
                                            Horário Ponta
                                        </Th>
                                        <Th colSpan={3} top={104} minWidth={150} sticky alignCenter color="#a3b0f0" backgroundColor="#252530">
                                            Horário F. Ponta
                                        </Th>
                                        <Th colSpan={3} top={104} minWidth={150} sticky alignCenter color="#67f087" backgroundColor="#252530">
                                            Horário Reservado
                                        </Th>
                                        <Th colSpan={2} alignCenter top={104} sticky backgroundColor="#222129">
                                            Total
                                        </Th>
                                        <Th colSpan={3} top={104} minWidth={150} sticky alignCenter color="#ff6e81" backgroundColor="#222129">
                                            Horário Ponta
                                        </Th>
                                        <Th colSpan={3} top={104} minWidth={150} sticky alignCenter color="#a3b0f0" backgroundColor="#222129">
                                            Horário F. Ponta
                                        </Th>
                                        <Th colSpan={3} top={104} minWidth={150} sticky alignCenter color="#67f087" backgroundColor="#222129">
                                            Horário Reservado
                                        </Th>
                                        <Th rowSpan={2} top={104} sticky alignCenter color="#ff6e81" backgroundColor="#272739">
                                            Horário Ponta
                                        </Th>
                                        <Th rowSpan={2} top={104} sticky alignCenter color="#a3b0f0" backgroundColor="#272739">
                                            Horário F. Ponta
                                        </Th>
                                        <Th rowSpan={2} top={104} sticky alignCenter color="#67f087" backgroundColor="#272739">
                                            Horário Reservado
                                        </Th>
                                        <Th rowSpan={2} top={104} sticky alignCenter backgroundColor="#30303d">
                                            <div>
                                                <img alt="" style={{ filter: "invert(1)" }} src={delta} width={15} height={15} />
                                                {" %"}
                                            </div>
                                            Ponta
                                        </Th>
                                        <Th rowSpan={2} top={104} sticky alignCenter backgroundColor="#30303d">
                                            <div>
                                                <img alt="" style={{ filter: "invert(1)" }} src={delta} width={15} height={15} />
                                                {" %"}
                                            </div>
                                            Reservado
                                        </Th>
                                        <Th rowSpan={2} top={104} sticky alignCenter backgroundColor="#30303d">
                                            Resultado Financeiro (R$)
                                        </Th>
                                    </Tr>
                                    <Tr>
                                        <Th top={147} sticky alignCenter backgroundColor="#252530">
                                            Qtd.
                                        </Th>
                                        <Th top={147} sticky alignCenter backgroundColor="#252530">
                                            %
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#daa710" backgroundColor="#252530">
                                            Alerta
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#ff6e81" backgroundColor="#252530">
                                            Qtd.
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#ff6e81" backgroundColor="#252530">
                                            %
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#daa710" backgroundColor="#252530">
                                            Alerta
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#a3b0f0" backgroundColor="#252530">
                                            Qtd.
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#a3b0f0" backgroundColor="#252530">
                                            %
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#daa710" backgroundColor="#252530">
                                            Alerta
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#67f087" backgroundColor="#252530">
                                            Qtd.
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#67f087" backgroundColor="#252530">
                                            %
                                        </Th>
                                        <Th top={147} sticky alignCenter backgroundColor="#222129">
                                            Qtd.
                                        </Th>
                                        <Th top={147} sticky alignCenter backgroundColor="#222129">
                                            %
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#daa710" backgroundColor="#222129">
                                            Alerta
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#ff6e81" backgroundColor="#222129">
                                            Qtd.
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#ff6e81" backgroundColor="#222129">
                                            %
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#daa710" backgroundColor="#222129">
                                            Alerta
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#a3b0f0" backgroundColor="#222129">
                                            Qtd.
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#a3b0f0" backgroundColor="#222129">
                                            %
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#daa710" backgroundColor="#222129">
                                            Alerta
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#67f087" backgroundColor="#222129">
                                            Qtd.
                                        </Th>
                                        <Th top={147} sticky alignCenter color="#67f087" backgroundColor="#222129">
                                            %
                                        </Th>
                                    </Tr>
                                </THead>
                                <TBody>
                                    {listaConsumoPercentualPorHorarioComparativoPeriodo.map((item, i) => {
                                        const grupoA = [1, 4].includes(parseInt(item.id_grupo_faturamento));
                                        const grupoB = [2, 3].includes(item.id_grupo_faturamento);
                                        const irrigante = !!item.irrigante;
                                        const temSubsidioIrrigante = !!item.subsidio_irrigante;

                                        //indicadores período A ------------------------------------------------------------------------------------------------------------------------------------
                                        const periodoA = item.periodoA;

                                        let periodoA_percentual_horario_ponta = parseFloat(periodoA.percentual_horario_ponta || 0);
                                        let periodoA_percentual_horario_fora_ponta = parseFloat(periodoA.percentual_horario_fora_ponta || 0);
                                        let periodoA_percentual_horario_reservado = parseFloat(periodoA.percentual_horario_reservado || 0);
                                        let periodoA_percentual_total =
                                            periodoA_percentual_horario_ponta + periodoA_percentual_horario_fora_ponta + periodoA_percentual_horario_reservado;

                                        let periodoA_consumo_horario_ponta = parseFloat(periodoA.consumo_horario_ponta || 0);
                                        let periodoA_consumo_horario_fora_ponta = parseFloat(periodoA.consumo_horario_fora_ponta || 0);
                                        let periodoA_consumo_horario_reservado = parseFloat(periodoA.consumo_horario_reservado || 0);
                                        let periodoA_consumo_total = periodoA_consumo_horario_ponta + periodoA_consumo_horario_fora_ponta + periodoA_consumo_horario_reservado;

                                        const periodoA_atintiuConsumoMinimo = periodoA_consumo_total > 2000;

                                        let periodoA_tooltipAlertaPonta = "";
                                        let periodoA_tooltipAlertaForaPonta = "";
                                        let periodoA_tooltipAlertaReservado = "";

                                        //VALIDAÇÃO ALERTA PONTA VERDE -----------------------------------------------------------------------------------------------------------------------------
                                        const periodoA_alertaPontaVerde =
                                            periodoA_atintiuConsumoMinimo &&
                                            ((!irrigante && grupoA && periodoA_percentual_horario_ponta <= 15) || (irrigante && grupoA && periodoA_percentual_horario_ponta <= 2));

                                        if (periodoA_alertaPontaVerde && periodoA_percentual_horario_ponta <= 15) {
                                            periodoA_tooltipAlertaPonta = "Consumo Ponta não passou de 15%";
                                        } else if (periodoA_alertaPontaVerde && periodoA_percentual_horario_ponta <= 2) {
                                            periodoA_tooltipAlertaPonta = "Consumo Ponta não passou de 2%";
                                        }

                                        //VALIDAÇÃO ALERTA PONTA VERMELHO --------------------------------------------------------------------------------------------------------------------------
                                        const periodoA_alertaPontaVermelho =
                                            periodoA_atintiuConsumoMinimo &&
                                            ((!irrigante && grupoA && periodoA_percentual_horario_ponta > 15) || (irrigante && grupoA && periodoA_percentual_horario_ponta > 2));

                                        if (periodoA_alertaPontaVermelho && periodoA_percentual_horario_ponta > 15) {
                                            periodoA_tooltipAlertaPonta = "Consumo Ponta passou de 15%";
                                        } else if (periodoA_alertaPontaVermelho && periodoA_percentual_horario_ponta > 2) {
                                            periodoA_tooltipAlertaPonta = "Consumo Ponta passou de 2%";
                                        }

                                        //VALIDAÇÃO ALERTA FORA PONTA VERDE -------------------------------------------------------------------------------------------------------------------------
                                        const periodoA_alertaForaPontaVerde =
                                            periodoA_atintiuConsumoMinimo &&
                                            ((!irrigante && grupoA && periodoA_percentual_horario_fora_ponta >= 85) ||
                                                (irrigante && grupoB && temSubsidioIrrigante && periodoA_percentual_horario_fora_ponta <= 60));

                                        if (periodoA_alertaForaPontaVerde && periodoA_percentual_horario_fora_ponta == 85) {
                                            periodoA_tooltipAlertaForaPonta = "Consumo Fora Ponta atingiu 85%";
                                        } else if (periodoA_alertaForaPontaVerde && periodoA_percentual_horario_fora_ponta > 85) {
                                            periodoA_tooltipAlertaForaPonta = "Consumo Fora Ponta passou de 85%";
                                        } else if (periodoA_alertaForaPontaVerde && periodoA_percentual_horario_fora_ponta <= 60) {
                                            periodoA_tooltipAlertaForaPonta = "Consumo Fora Ponta não passou de 60%";
                                        }

                                        //VALIDAÇÃO ALERTA FORA PONTA VERMELHO ---------------------------------------------------------------------------------------------------------------------
                                        const periodoA_alertaForaPontaVermelho =
                                            periodoA_atintiuConsumoMinimo &&
                                            ((!irrigante && grupoA && periodoA_percentual_horario_fora_ponta < 85) ||
                                                (irrigante && grupoB && temSubsidioIrrigante && periodoA_percentual_horario_fora_ponta > 60));

                                        if (periodoA_alertaForaPontaVermelho && periodoA_percentual_horario_fora_ponta < 85) {
                                            periodoA_tooltipAlertaForaPonta = "Consumo Fora Ponta ficou abaixo de 85%";
                                        } else if (periodoA_alertaForaPontaVermelho && periodoA_percentual_horario_fora_ponta > 60) {
                                            periodoA_tooltipAlertaForaPonta = "Consumo Fora Ponta passou de 60%";
                                        }

                                        //VALIDAÇÃO ALERTA RESERVADO VERDE -------------------------------------------------------------------------------------------------------------------------

                                        // Não existe ponta para o irrigante grupo B. Então o alerta deve ser:

                                        //     Positivo em verde  - Consumo reservado maior ou igual a 35% dessa unidade;

                                        //     Advertência em vermelho - Consumo reservado menor que 35% dessa unidade.

                                        const periodoA_alertaReservadoVerde =
                                            periodoA_atintiuConsumoMinimo &&
                                            ((irrigante && grupoA && temSubsidioIrrigante && periodoA_percentual_horario_reservado >= 40) ||
                                                (irrigante && grupoB && temSubsidioIrrigante && periodoA_percentual_horario_reservado >= 35));

                                        if (irrigante && grupoA && temSubsidioIrrigante && periodoA_percentual_horario_reservado == 40) {
                                            periodoA_tooltipAlertaReservado = "Consumo Reservado atingiu 40%";
                                        } else if (irrigante && grupoA && temSubsidioIrrigante && periodoA_percentual_horario_reservado > 40) {
                                            periodoA_tooltipAlertaReservado = "Consumo Reservado passou de 40%";
                                        } else if (irrigante && grupoB && temSubsidioIrrigante && periodoA_percentual_horario_reservado == 35) {
                                            periodoA_tooltipAlertaReservado = "Consumo Reservado atingiu 35%";
                                        } else if (irrigante && grupoB && temSubsidioIrrigante && periodoA_percentual_horario_reservado > 35) {
                                            periodoA_tooltipAlertaReservado = "Consumo Reservado passou de 35%";
                                        }

                                        //VALIDAÇÃO ALERTA RESERVADO VERMELHO ----------------------------------------------------------------------------------------------------------------------
                                        const periodoA_alertaReservadoVermelho =
                                            periodoA_atintiuConsumoMinimo &&
                                            ((irrigante && grupoA && temSubsidioIrrigante && periodoA_percentual_horario_reservado < 40) ||
                                                (irrigante && grupoB && temSubsidioIrrigante && periodoA_percentual_horario_reservado < 35));

                                        if (irrigante && grupoA && temSubsidioIrrigante && periodoA_percentual_horario_reservado < 40) {
                                            periodoA_tooltipAlertaReservado = "Consumo Reservado ficou abaixo de 40%";
                                        } else if (irrigante && grupoB && temSubsidioIrrigante && periodoA_percentual_horario_reservado < 35) {
                                            periodoA_tooltipAlertaReservado = "Consumo Reservado ficou abaixo de 35%";
                                        }

                                        //indicadores periodo B ------------------------------------------------------------------------------------------------------------------------------------
                                        const periodoB = item.periodoB || {};

                                        let periodoB_percentual_horario_ponta = parseFloat(periodoB.percentual_horario_ponta || 0);
                                        let periodoB_percentual_horario_fora_ponta = parseFloat(periodoB.percentual_horario_fora_ponta || 0);
                                        let periodoB_percentual_horario_reservado = parseFloat(periodoB.percentual_horario_reservado || 0);
                                        let periodoB_percentual_total =
                                            periodoB_percentual_horario_ponta + periodoB_percentual_horario_fora_ponta + periodoB_percentual_horario_reservado;

                                        let periodoB_consumo_horario_ponta = parseFloat(periodoB.consumo_horario_ponta || 0);
                                        let periodoB_consumo_horario_fora_ponta = parseFloat(periodoB.consumo_horario_fora_ponta || 0);
                                        let periodoB_consumo_horario_reservado = parseFloat(periodoB.consumo_horario_reservado || 0);
                                        let periodoB_consumo_total = periodoB_consumo_horario_ponta + periodoB_consumo_horario_fora_ponta + periodoB_consumo_horario_reservado;

                                        const periodoB_atintiuConsumoMinimo = periodoB_consumo_total > 2000;

                                        let periodoB_tooltipAlertaPonta = "";
                                        let periodoB_tooltipAlertaForaPonta = "";
                                        let periodoB_tooltipAlertaReservado = "";

                                        //VALIDAÇÃO ALERTA PONTA VERDE -----------------------------------------------------------------------------------------------------------------------------
                                        const periodoB_alertaPontaVerde =
                                            periodoB_atintiuConsumoMinimo &&
                                            ((!irrigante && grupoA && periodoB_percentual_horario_ponta <= 15) || (irrigante && grupoA && periodoB_percentual_horario_ponta <= 2));

                                        if (periodoB_alertaPontaVerde && periodoB_percentual_horario_ponta <= 15) {
                                            periodoB_tooltipAlertaPonta = "Consumo Ponta não passou de 15%";
                                        } else if (periodoB_alertaPontaVerde && periodoB_percentual_horario_ponta <= 2) {
                                            periodoB_tooltipAlertaPonta = "Consumo Ponta não passou de 2%";
                                        }

                                        //VALIDAÇÃO ALERTA PONTA VERMELHO --------------------------------------------------------------------------------------------------------------------------
                                        const periodoB_alertaPontaVermelho =
                                            periodoB_atintiuConsumoMinimo &&
                                            ((!irrigante && grupoB && periodoB_percentual_horario_ponta > 15) || (irrigante && grupoA && periodoB_percentual_horario_ponta > 2));

                                        if (periodoB_alertaPontaVermelho && periodoB_percentual_horario_ponta > 15) {
                                            periodoB_tooltipAlertaPonta = "Consumo Ponta passou de 15%";
                                        } else if (periodoB_alertaPontaVermelho && periodoB_percentual_horario_ponta > 2) {
                                            periodoB_tooltipAlertaPonta = "Consumo Ponta passou de 2%";
                                        }

                                        //VALIDAÇÃO ALERTA FORA PONTA VERDE -------------------------------------------------------------------------------------------------------------------------
                                        const periodoB_alertaForaPontaVerde =
                                            periodoB_atintiuConsumoMinimo &&
                                            ((!irrigante && grupoA && periodoB_percentual_horario_fora_ponta >= 85) ||
                                                (irrigante && grupoB && temSubsidioIrrigante && periodoB_percentual_horario_fora_ponta <= 60));

                                        if (periodoB_alertaForaPontaVerde && periodoB_percentual_horario_fora_ponta == 85) {
                                            periodoB_tooltipAlertaForaPonta = "Consumo Fora Ponta atingiu 85%";
                                        } else if (periodoB_alertaForaPontaVerde && periodoB_percentual_horario_fora_ponta > 85) {
                                            periodoB_tooltipAlertaForaPonta = "Consumo Fora Ponta passou de 85%";
                                        } else if (periodoB_alertaForaPontaVerde && periodoB_percentual_horario_fora_ponta <= 60) {
                                            periodoB_tooltipAlertaForaPonta = "Consumo Fora Ponta não passou de 60%";
                                        }

                                        //VALIDAÇÃO ALERTA FORA PONTA VERMELHO ---------------------------------------------------------------------------------------------------------------------
                                        const periodoB_alertaForaPontaVermelho =
                                            periodoB_atintiuConsumoMinimo &&
                                            ((!irrigante && grupoA && periodoB_percentual_horario_fora_ponta < 85) ||
                                                (irrigante && grupoB && temSubsidioIrrigante && periodoB_percentual_horario_fora_ponta > 60));

                                        if (periodoB_alertaForaPontaVermelho && periodoB_percentual_horario_fora_ponta < 85) {
                                            periodoB_tooltipAlertaForaPonta = "Consumo Fora Ponta ficou abaixo de 85%";
                                        } else if (periodoB_alertaForaPontaVermelho && periodoB_percentual_horario_fora_ponta > 60) {
                                            periodoB_tooltipAlertaForaPonta = "Consumo Fora Ponta passou de 60%";
                                        }

                                        //VALIDAÇÃO ALERTA RESERVADO VERDE -------------------------------------------------------------------------------------------------------------------------
                                        const periodoB_alertaReservadoVerde =
                                            periodoB_atintiuConsumoMinimo &&
                                            ((irrigante && grupoA && temSubsidioIrrigante && periodoB_percentual_horario_reservado >= 40) ||
                                                (irrigante && grupoB && temSubsidioIrrigante && periodoB_percentual_horario_reservado >= 35));

                                        if (irrigante && grupoA && temSubsidioIrrigante && periodoB_percentual_horario_reservado == 40) {
                                            periodoB_tooltipAlertaReservado = "Consumo Reservado atingiu 40%";
                                        } else if (irrigante && grupoA && temSubsidioIrrigante && periodoB_percentual_horario_reservado > 40) {
                                            periodoB_tooltipAlertaReservado = "Consumo Reservado passou de 40%";
                                        } else if (irrigante && grupoB && temSubsidioIrrigante && periodoB_percentual_horario_reservado == 35) {
                                            periodoB_tooltipAlertaReservado = "Consumo Reservado atingiu 35%";
                                        } else if (irrigante && grupoB && temSubsidioIrrigante && periodoB_percentual_horario_reservado > 35) {
                                            periodoB_tooltipAlertaReservado = "Consumo Reservado passou de 35%";
                                        }

                                        //VALIDAÇÃO ALERTA RESERVADO VERMELHO ----------------------------------------------------------------------------------------------------------------------
                                        const periodoB_alertaReservadoVermelho =
                                            periodoB_atintiuConsumoMinimo &&
                                            ((irrigante && grupoA && temSubsidioIrrigante && periodoB_percentual_horario_reservado < 40) ||
                                                (irrigante && grupoB && temSubsidioIrrigante && periodoB_percentual_horario_reservado < 35));

                                        if (irrigante && grupoA && temSubsidioIrrigante && periodoB_percentual_horario_reservado < 40) {
                                            periodoB_tooltipAlertaReservado = "Consumo Reservado ficou abaixo de 40%";
                                        } else if (irrigante && grupoB && temSubsidioIrrigante && periodoB_percentual_horario_reservado < 35) {
                                            periodoB_tooltipAlertaReservado = "Consumo Reservado ficou abaixo de 35%";
                                        }

                                        const diferencaHorarioPontaConsumo = parseFloat(periodoB.consumo_horario_ponta - periodoA.consumo_horario_ponta) || 0;
                                        const diferencaHorarioPontaPercentual = parseFloat(periodoB.percentual_horario_ponta - periodoA.percentual_horario_ponta) || 0;

                                        //muda pra negativo quando o ponta é positivo, pois se aumentou consumo ponta ta dando prejuizo
                                        const diferencaHorarioPontaConsumoParaCalcularRetornoFinanceiro =
                                            diferencaHorarioPontaConsumo * (diferencaHorarioPontaConsumo > 0 ? -1 : 1);
                                        //multiplica a diferença de consumo resultante pelo valor da tarifa da competencia final do período B
                                        const retornoFinanceiroPonta = diferencaHorarioPontaConsumoParaCalcularRetornoFinanceiro * parseFloat(periodoB.tarifa_horario_ponta || 0);

                                        const diferencaHorarioReservadoConsumo = parseFloat(periodoB.consumo_horario_reservado - periodoA.consumo_horario_reservado) || 0;
                                        const diferencaHorarioReservadoPercentual = parseFloat(periodoB.percentual_horario_reservado - periodoA.percentual_horario_reservado) || 0;
                                        const retornoFinanceiroReservado = diferencaHorarioReservadoConsumo * parseFloat(periodoB.tarifa_horario_reservado || 0);

                                        //contabiliza os totais par ao rodapé
                                        const prefixo = irrigante ? "" : "nao_";
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_consumo_total_a"] += periodoA_consumo_total;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_consumo_ponta_a"] += periodoA_consumo_horario_ponta;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_consumo_fora_ponta_a"] += periodoA_consumo_horario_fora_ponta;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_consumo_reservado_a"] += periodoA_consumo_horario_reservado;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_consumo_total_b"] += periodoB_consumo_total;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_consumo_ponta_b"] += periodoB_consumo_horario_ponta;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_consumo_fora_ponta_b"] += periodoB_consumo_horario_fora_ponta;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_consumo_reservado_b"] += periodoB_consumo_horario_reservado;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_retorno_financeiro_ponta"] += retornoFinanceiroPonta;
                                        totaisTabelaHorariosComparativoPeriodo[prefixo + "irrigantes_retorno_financeiro_reservado"] += retornoFinanceiroReservado;

                                        return (
                                            <Tr key={i}>
                                                <Td minWidth={150} color="#fff">
                                                    {item.agrupador.substring(0, 80)}
                                                    {item.agrupador.length > 80 ? "..." : ""}
                                                </Td>
                                                <Td backgroundColor="#252530" color="#fff" alignCenter>
                                                    {periodoA_consumo_total.toFixed(2).replace(".", ",")}
                                                </Td>
                                                <Td minWidth={50} backgroundColor="#252530" color="#fff" alignCenter>
                                                    {periodoA_percentual_total.toFixed(0).replace(".", ",")}
                                                    {" %"}
                                                </Td>
                                                <Td backgroundColor="#252530" alignCenter>
                                                    {periodoA_alertaPontaVerde ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#26bc58",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-thumbs-up"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {periodoA_alertaPontaVermelho ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#c73b55",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-exclamation-circle"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {!periodoA_alertaPontaVerde && !periodoA_alertaPontaVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                </Td>
                                                <Td alignCenter color="#ff6e81" backgroundColor="#252530">
                                                    <p style={{ margin: 2 }}>{periodoA_consumo_horario_ponta.toFixed(2).replace(".", ",")}</p>
                                                    kWh
                                                </Td>
                                                <Td
                                                    minWidth={50}
                                                    alignCenter
                                                    color="#ff6e81"
                                                    backgroundColor="#252530"
                                                    title={periodoA_tooltipAlertaPonta}
                                                    style={{
                                                        border: periodoA_alertaPontaVerde ? "1px solid #26bc58" : periodoA_alertaPontaVermelho ? "1px solid #c73b55" : null,
                                                    }}
                                                >
                                                    {periodoA_percentual_horario_ponta.toFixed(2).replace(".", ",")} %
                                                </Td>
                                                <Td backgroundColor="#252530" alignCenter>
                                                    {periodoA_alertaForaPontaVerde ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#26bc58",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-thumbs-up"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {periodoA_alertaForaPontaVermelho ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#c73b55",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-exclamation-circle"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {!periodoA_alertaForaPontaVerde && !periodoA_alertaForaPontaVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                </Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#252530">
                                                    <p style={{ margin: 2 }}>{periodoA_consumo_horario_fora_ponta.toFixed(2).replace(".", ",")}</p>
                                                    kWh
                                                </Td>
                                                <Td
                                                    minWidth={50}
                                                    alignCenter
                                                    color="#a3b0f0"
                                                    backgroundColor="#252530"
                                                    title={periodoA_tooltipAlertaForaPonta}
                                                    style={{
                                                        border: periodoA_alertaForaPontaVerde ? "1px solid #26bc58" : periodoA_alertaForaPontaVermelho ? "1px solid #c73b55" : null,
                                                    }}
                                                >
                                                    {periodoA_percentual_horario_fora_ponta.toFixed(2).replace(".", ",")} %
                                                </Td>
                                                <Td backgroundColor="#252530" alignCenter>
                                                    {periodoA_alertaReservadoVerde ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#26bc58",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-thumbs-up"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {periodoA_alertaReservadoVermelho ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#c73b55",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-exclamation-circle"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {!periodoA_alertaReservadoVerde && !periodoA_alertaReservadoVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                </Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#252530">
                                                    <p style={{ margin: 2 }}> {periodoA_consumo_horario_reservado.toFixed(2).replace(".", ",")}</p>
                                                    kWh
                                                </Td>
                                                <Td
                                                    minWidth={50}
                                                    alignCenter
                                                    color="#67f087"
                                                    backgroundColor="#252530"
                                                    title={periodoA_tooltipAlertaReservado}
                                                    style={{
                                                        border: periodoA_alertaReservadoVerde ? "1px solid #26bc58" : periodoA_alertaReservadoVermelho ? "1px solid #c73b55" : null,
                                                    }}
                                                >
                                                    {periodoA_percentual_horario_reservado.toFixed(2).replace(".", ",")} %
                                                </Td>

                                                {/* --------------------------------------------------------------------------------------------------------------------------------- */}
                                                <Td backgroundColor="#222129" color="#fff" alignCenter>
                                                    {periodoB_consumo_total.toFixed(2).replace(".", ",")}
                                                </Td>
                                                <Td minWidth={50} backgroundColor="#222129" color="#fff" alignCenter>
                                                    {periodoB_percentual_total.toFixed(0).replace(".", ",")}
                                                    {" %"}
                                                </Td>
                                                <Td backgroundColor="#222129" alignCenter>
                                                    {periodoB_alertaPontaVerde ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#26bc58",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-thumbs-up"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {periodoB_alertaPontaVermelho ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#c73b55",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-exclamation-circle"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {!periodoB_alertaPontaVerde && !periodoB_alertaPontaVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                </Td>
                                                <Td alignCenter color="#ff6e81" backgroundColor="#222129">
                                                    <p style={{ margin: 2 }}>{periodoB_consumo_horario_ponta.toFixed(2).replace(".", ",")}</p>
                                                    kWh
                                                </Td>
                                                <Td
                                                    minWidth={50}
                                                    alignCenter
                                                    color="#ff6e81"
                                                    backgroundColor="#222129"
                                                    title={periodoB_tooltipAlertaPonta}
                                                    style={{
                                                        border: periodoB_alertaPontaVerde ? "1px solid #26bc58" : periodoB_alertaPontaVermelho ? "1px solid #c73b55" : null,
                                                    }}
                                                >
                                                    {periodoB_percentual_horario_ponta.toFixed(2).replace(".", ",")} %
                                                </Td>
                                                <Td backgroundColor="#222129" alignCenter>
                                                    {periodoB_alertaForaPontaVerde ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#26bc58",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-thumbs-up"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {periodoB_alertaForaPontaVermelho ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#c73b55",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-exclamation-circle"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {!periodoB_alertaForaPontaVerde && !periodoB_alertaForaPontaVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                </Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#222129">
                                                    <p style={{ margin: 2 }}>{periodoB_consumo_horario_fora_ponta.toFixed(2).replace(".", ",")}</p>
                                                    kWh
                                                </Td>
                                                <Td
                                                    minWidth={50}
                                                    alignCenter
                                                    color="#a3b0f0"
                                                    backgroundColor="#222129"
                                                    title={periodoB_tooltipAlertaForaPonta}
                                                    style={{
                                                        border: periodoB_alertaForaPontaVerde ? "1px solid #26bc58" : periodoB_alertaForaPontaVermelho ? "1px solid #c73b55" : null,
                                                    }}
                                                >
                                                    {periodoB_percentual_horario_fora_ponta.toFixed(2).replace(".", ",")} %
                                                </Td>
                                                <Td backgroundColor="#222129" alignCenter>
                                                    {periodoB_alertaReservadoVerde ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#26bc58",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-thumbs-up"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {periodoB_alertaReservadoVermelho ? (
                                                        <>
                                                            <i
                                                                style={{
                                                                    color: "#c73b55",
                                                                    marginRight: 5,
                                                                }}
                                                                className="fas fa-exclamation-circle"
                                                            ></i>
                                                            <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {!periodoB_alertaReservadoVerde && !periodoB_alertaReservadoVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                </Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#222129">
                                                    <p style={{ margin: 2 }}>{periodoB_consumo_horario_reservado.toFixed(2).replace(".", ",")}</p>
                                                    kWh
                                                </Td>
                                                <Td
                                                    minWidth={50}
                                                    alignCenter
                                                    color="#67f087"
                                                    backgroundColor="#222129"
                                                    title={periodoB_tooltipAlertaReservado}
                                                    style={{
                                                        border: periodoB_alertaReservadoVerde ? "1px solid #26bc58" : periodoB_alertaReservadoVermelho ? "1px solid #c73b55" : null,
                                                    }}
                                                >
                                                    {periodoB_percentual_horario_reservado.toFixed(2).replace(".", ",")} %
                                                </Td>

                                                <Td alignCenter color="#ff6e81" backgroundColor="#272739">
                                                    R${" "}
                                                    {parseFloat(periodoB.tarifa_horario_ponta || 0)
                                                        .toFixed(2)
                                                        .replace(".", ",")}
                                                </Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#272739">
                                                    R${" "}
                                                    {parseFloat(periodoB.tarifa_horario_fora_ponta || 0)
                                                        .toFixed(2)
                                                        .replace(".", ",")}
                                                </Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#272739">
                                                    R${" "}
                                                    {parseFloat(periodoB.tarifa_horario_reservado || 0)
                                                        .toFixed(2)
                                                        .replace(".", ",")}
                                                </Td>
                                                <Td
                                                    minWidth={50}
                                                    noWrap={true}
                                                    alignCenter
                                                    color="#FFF"
                                                    title="% Ponta do período B - % Ponta do período A"
                                                    backgroundColor={diferencaHorarioPontaPercentual > 0 ? "#ff3d56" : diferencaHorarioPontaPercentual < 0 ? "#43b85d" : "#30303d"}
                                                >
                                                    {diferencaHorarioPontaPercentual > 0 ? (
                                                        <i className="fas fa-arrow-up" />
                                                    ) : diferencaHorarioPontaPercentual < 0 ? (
                                                        <i className="fas fa-arrow-down" />
                                                    ) : null}{" "}
                                                    {Math.abs(diferencaHorarioPontaPercentual).toFixed(2).replace(".", ",")}
                                                    {" %"}
                                                    <div style={{ fontSize: "0.6rem" }}>
                                                        {Math.abs(diferencaHorarioPontaConsumo).toFixed(2).replace(".", ",")}
                                                        {" kWh"}
                                                    </div>
                                                </Td>
                                                <Td
                                                    minWidth={50}
                                                    noWrap={true}
                                                    title="% Reservado do período B - % Reservado do período A"
                                                    alignCenter
                                                    color="#FFF"
                                                    backgroundColor={
                                                        diferencaHorarioReservadoPercentual > 0 ? "#43b85d" : diferencaHorarioReservadoPercentual < 0 ? "#ff3d56" : "#30303d"
                                                    }
                                                >
                                                    {diferencaHorarioReservadoPercentual > 0 ? (
                                                        <i className="fas fa-arrow-up" />
                                                    ) : diferencaHorarioReservadoPercentual < 0 ? (
                                                        <i className="fas fa-arrow-down" />
                                                    ) : null}{" "}
                                                    {Math.abs(diferencaHorarioReservadoPercentual).toFixed(2).replace(".", ",")}
                                                    {" %"}
                                                    <div style={{ fontSize: "0.6rem" }}>
                                                        {Math.abs(diferencaHorarioReservadoConsumo).toFixed(2).replace(".", ",")}
                                                        {" kWh"}
                                                    </div>
                                                </Td>
                                                <Td alignCenter color="#FFF" backgroundColor="#30303d">
                                                    <div style={{ fontSize: "0.75rem" }}>
                                                        <div style={{ color: "#ff6e81", border: "1px solid #ff6e81", padding: 2 }}>
                                                            <div>
                                                                <b> Ponta</b>
                                                            </div>
                                                            {"R$ " + adicionarPontosMilhar(retornoFinanceiroPonta)}
                                                        </div>
                                                        <div style={{ color: "#67f087", border: "1px solid #67f087", padding: 2 }}>
                                                            <div>
                                                                <b> Reservado</b>
                                                            </div>
                                                            {"R$ " + adicionarPontosMilhar(retornoFinanceiroReservado)}
                                                        </div>
                                                        <div
                                                            style={{
                                                                color:
                                                                    retornoFinanceiroPonta + retornoFinanceiroReservado > 0
                                                                        ? "#43b85d"
                                                                        : retornoFinanceiroPonta + retornoFinanceiroReservado < 0
                                                                        ? "#ff3d56"
                                                                        : "#FFF",
                                                                border: `1px solid ${
                                                                    retornoFinanceiroPonta + retornoFinanceiroReservado > 0
                                                                        ? "#43b85d"
                                                                        : retornoFinanceiroPonta + retornoFinanceiroReservado < 0
                                                                        ? "#ff3d56"
                                                                        : "#FFF"
                                                                }`,
                                                                padding: 2,
                                                            }}
                                                        >
                                                            <div>
                                                                <b> Total Resultante</b>
                                                            </div>
                                                            {"R$ " + adicionarPontosMilhar(retornoFinanceiroPonta + retornoFinanceiroReservado)}
                                                        </div>
                                                    </div>
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                                    <>
                                        {listaConsumoPercentualPorHorarioComparativoPeriodo.find((item) => item.irrigante) ? (
                                            <Tr>
                                                <Td minWidth={150} backgroundColor="#006cba" color="#fff">
                                                    Totais Unidades Irrigantes
                                                </Td>
                                                <Td backgroundColor="#006cba" color="#fff" alignCenter>
                                                    {totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a.toFixed(2).replace(".", ",")}
                                                </Td>
                                                <Td minWidth={50} backgroundColor="#006cba" color="#fff" alignCenter>
                                                    100 %
                                                </Td>
                                                <Td backgroundColor="#006cba" alignCenter></Td>
                                                <Td alignCenter color="#ff6e81" backgroundColor="#006cba">
                                                    <p style={{ margin: 2 }}>{totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_a.toFixed(2).replace(".", ",")}</p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#ff6e81" backgroundColor="#006cba">
                                                    {(totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_a * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>
                                                <Td backgroundColor="#006cba" alignCenter></Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#006cba">
                                                    <p style={{ margin: 2 }}>
                                                        {totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_fora_ponta_a.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#a3b0f0" backgroundColor="#006cba">
                                                    {(totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_fora_ponta_a * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>
                                                <Td backgroundColor="#006cba" alignCenter></Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#006cba">
                                                    <p style={{ margin: 2 }}>
                                                        {" "}
                                                        {totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_a.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#67f087" backgroundColor="#006cba">
                                                    {(totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_a * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>

                                                {/* --------------------------------------------------------------------------------------------------------------------------------- */}
                                                <Td backgroundColor="#006cba" color="#fff" alignCenter>
                                                    {totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b.toFixed(2).replace(".", ",")}
                                                </Td>
                                                <Td minWidth={50} backgroundColor="#006cba" color="#fff" alignCenter>
                                                    100 %
                                                </Td>
                                                <Td backgroundColor="#006cba" alignCenter></Td>
                                                <Td alignCenter color="#ff6e81" backgroundColor="#006cba">
                                                    <p style={{ margin: 2 }}>{totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_b.toFixed(2).replace(".", ",")}</p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#ff6e81" backgroundColor="#006cba">
                                                    {(totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>
                                                <Td backgroundColor="#006cba" alignCenter></Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#006cba">
                                                    <p style={{ margin: 2 }}>
                                                        {totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_fora_ponta_b.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#a3b0f0" backgroundColor="#006cba">
                                                    {(totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_fora_ponta_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>
                                                <Td backgroundColor="#006cba" alignCenter></Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#006cba">
                                                    <p style={{ margin: 2 }}>
                                                        {" "}
                                                        {totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_b.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#67f087" backgroundColor="#006cba">
                                                    {(totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>

                                                <Td alignCenter color="#ff6e81" backgroundColor="#006cba"></Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#006cba"></Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#006cba"></Td>
                                                <Td
                                                    minWidth={70}
                                                    noWrap={true}
                                                    alignCenter
                                                    color="#FFF"
                                                    title="% Ponta do período B - % Ponta do período A"
                                                    backgroundColor={
                                                        (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_b * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                            : 0) -
                                                            (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                                ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_a * 100) /
                                                                  totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                                : 0) >
                                                        0
                                                            ? "#ff3d56"
                                                            : (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                                  ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_b * 100) /
                                                                    totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                                  : 0) -
                                                                  (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                                      ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_a * 100) /
                                                                        totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                                      : 0) <
                                                              0
                                                            ? "#43b85d"
                                                            : "#006cba"
                                                    }
                                                >
                                                    {(totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                        : 0) -
                                                        (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_a * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                            : 0) >
                                                    0 ? (
                                                        <i className="fas fa-arrow-up" />
                                                    ) : (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                          ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_b * 100) /
                                                            totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                          : 0) -
                                                          (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                              ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_a * 100) /
                                                                totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                              : 0) <
                                                      0 ? (
                                                        <i className="fas fa-arrow-down" />
                                                    ) : null}
                                                    {Math.abs(
                                                        (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_b * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                            : 0) -
                                                            (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                                ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_a * 100) /
                                                                  totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                                : 0)
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}
                                                    {" %"}
                                                    <div style={{ fontSize: "0.6rem" }}>
                                                        {Math.abs(
                                                            totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_b -
                                                                totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_ponta_a
                                                        )
                                                            .toFixed(2)
                                                            .replace(".", ",")}
                                                        {" kWh"}
                                                    </div>
                                                </Td>
                                                <Td
                                                    minWidth={70}
                                                    noWrap={true}
                                                    title="% Reservado do período B - % Reservado do período A"
                                                    alignCenter
                                                    color="#FFF"
                                                    backgroundColor={
                                                        (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_b * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                            : 0) -
                                                            (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                                ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_a * 100) /
                                                                  totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                                : 0) >
                                                        0
                                                            ? "#43b85d"
                                                            : (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                                  ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_b * 100) /
                                                                    totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                                  : 0) -
                                                                  (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                                      ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_a * 100) /
                                                                        totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                                      : 0) <
                                                              0
                                                            ? "#ff3d56"
                                                            : "#006cba"
                                                    }
                                                >
                                                    {(totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                        : 0) -
                                                        (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_a * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                            : 0) >
                                                    0 ? (
                                                        <i className="fas fa-arrow-up" />
                                                    ) : (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                          ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_b * 100) /
                                                            totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                          : 0) -
                                                          (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                              ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_a * 100) /
                                                                totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                              : 0) <
                                                      0 ? (
                                                        <i className="fas fa-arrow-down" />
                                                    ) : null}
                                                    {Math.abs(
                                                        (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_b * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_b
                                                            : 0) -
                                                            (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a > 0
                                                                ? (totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_a * 100) /
                                                                  totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_total_a
                                                                : 0)
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}
                                                    {" %"}
                                                    <div style={{ fontSize: "0.6rem" }}>
                                                        {Math.abs(
                                                            totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_b -
                                                                totaisTabelaHorariosComparativoPeriodo.irrigantes_consumo_reservado_a
                                                        )
                                                            .toFixed(2)
                                                            .replace(".", ",")}
                                                        {" kWh"}
                                                    </div>
                                                </Td>
                                                <Td alignCenter color="#FFF" backgroundColor="#006cba">
                                                    <div style={{ fontSize: "0.75rem" }}>
                                                        <div style={{ color: "#ff6e81", border: "1px solid #ff6e81", padding: 2 }}>
                                                            <div>
                                                                <b> Ponta</b>
                                                            </div>
                                                            {"R$ " + adicionarPontosMilhar(totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_ponta)}
                                                        </div>
                                                        <div style={{ color: "#67f087", border: "1px solid #67f087", padding: 2 }}>
                                                            <div>
                                                                <b> Reservado</b>
                                                            </div>
                                                            {"R$ " + adicionarPontosMilhar(totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_reservado)}
                                                        </div>
                                                        <div
                                                            style={{
                                                                color:
                                                                    totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_ponta +
                                                                        totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_reservado >
                                                                    0
                                                                        ? "#43b85d"
                                                                        : totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_ponta +
                                                                              totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_reservado <
                                                                          0
                                                                        ? "#ff3d56"
                                                                        : "#FFF",
                                                                border: `1px solid ${
                                                                    totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_ponta +
                                                                        totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_reservado >
                                                                    0
                                                                        ? "#43b85d"
                                                                        : totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_ponta +
                                                                              totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_reservado <
                                                                          0
                                                                        ? "#ff3d56"
                                                                        : "#FFF"
                                                                }`,
                                                                padding: 2,
                                                            }}
                                                        >
                                                            <div>
                                                                <b> Total Resultante</b>
                                                            </div>
                                                            {"R$ " +
                                                                adicionarPontosMilhar(
                                                                    totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_ponta +
                                                                        totaisTabelaHorariosComparativoPeriodo.irrigantes_retorno_financeiro_reservado
                                                                )}
                                                        </div>
                                                    </div>
                                                </Td>
                                            </Tr>
                                        ) : null}
                                        {listaConsumoPercentualPorHorarioComparativoPeriodo.find((item) => !item.irrigante) ? (
                                            <Tr>
                                                <Td minWidth={150} color="#fff" backgroundColor="#005592">
                                                    Totais Unidades Não Irrigantes
                                                </Td>
                                                <Td backgroundColor="#005592" color="#fff" alignCenter>
                                                    {totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a.toFixed(2).replace(".", ",")}
                                                </Td>
                                                <Td minWidth={50} backgroundColor="#005592" color="#fff" alignCenter>
                                                    100 %
                                                </Td>
                                                <Td backgroundColor="#005592" alignCenter></Td>
                                                <Td alignCenter color="#ff6e81" backgroundColor="#005592">
                                                    <p style={{ margin: 2 }}>
                                                        {totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_a.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#ff6e81" backgroundColor="#005592">
                                                    {(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_a * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>
                                                <Td backgroundColor="#005592" alignCenter></Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#005592">
                                                    <p style={{ margin: 2 }}>
                                                        {totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_fora_ponta_a.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#a3b0f0" backgroundColor="#005592">
                                                    {(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_fora_ponta_a * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>
                                                <Td backgroundColor="#005592" alignCenter></Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#005592">
                                                    <p style={{ margin: 2 }}>
                                                        {" "}
                                                        {totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_a.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#67f087" backgroundColor="#005592">
                                                    {(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_a * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>

                                                {/* --------------------------------------------------------------------------------------------------------------------------------- */}
                                                <Td backgroundColor="#005592" color="#fff" alignCenter>
                                                    {totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b.toFixed(2).replace(".", ",")}
                                                </Td>
                                                <Td minWidth={50} backgroundColor="#005592" color="#fff" alignCenter>
                                                    100 %
                                                </Td>
                                                <Td backgroundColor="#005592" alignCenter></Td>
                                                <Td alignCenter color="#ff6e81" backgroundColor="#005592">
                                                    <p style={{ margin: 2 }}>
                                                        {totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_b.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#ff6e81" backgroundColor="#005592">
                                                    {(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>
                                                <Td backgroundColor="#005592" alignCenter></Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#005592">
                                                    <p style={{ margin: 2 }}>
                                                        {totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_fora_ponta_b.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#a3b0f0" backgroundColor="#005592">
                                                    {(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_fora_ponta_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>
                                                <Td backgroundColor="#005592" alignCenter></Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#005592">
                                                    <p style={{ margin: 2 }}>
                                                        {" "}
                                                        {totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_b.toFixed(2).replace(".", ",")}
                                                    </p>
                                                    kWh
                                                </Td>
                                                <Td minWidth={50} alignCenter color="#67f087" backgroundColor="#005592">
                                                    {(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                        : 0
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}{" "}
                                                    %
                                                </Td>

                                                <Td alignCenter color="#ff6e81" backgroundColor="#005592"></Td>
                                                <Td alignCenter color="#a3b0f0" backgroundColor="#005592"></Td>
                                                <Td alignCenter color="#67f087" backgroundColor="#005592"></Td>
                                                <Td
                                                    minWidth={70}
                                                    noWrap={true}
                                                    alignCenter
                                                    color="#FFF"
                                                    title="% Ponta do período B - % Ponta do período A"
                                                    backgroundColor={
                                                        (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_b * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                            : 0) -
                                                            (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                                ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_a * 100) /
                                                                  totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                                : 0) >
                                                        0
                                                            ? "#ff3d56"
                                                            : (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                                  ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_b * 100) /
                                                                    totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                                  : 0) -
                                                                  (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                                      ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_a * 100) /
                                                                        totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                                      : 0) <
                                                              0
                                                            ? "#43b85d"
                                                            : "#005592"
                                                    }
                                                >
                                                    {(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                        : 0) -
                                                        (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_a * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                            : 0) >
                                                    0 ? (
                                                        <i className="fas fa-arrow-up" />
                                                    ) : (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                          ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_b * 100) /
                                                            totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                          : 0) -
                                                          (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                              ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_a * 100) /
                                                                totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                              : 0) <
                                                      0 ? (
                                                        <i className="fas fa-arrow-down" />
                                                    ) : null}
                                                    {Math.abs(
                                                        (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_b * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                            : 0) -
                                                            (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                                ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_a * 100) /
                                                                  totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                                : 0)
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}
                                                    {" %"}
                                                    <div style={{ fontSize: "0.6rem" }}>
                                                        {Math.abs(
                                                            totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_b -
                                                                totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_ponta_a
                                                        )
                                                            .toFixed(2)
                                                            .replace(".", ",")}
                                                        {" kWh"}
                                                    </div>
                                                </Td>
                                                <Td
                                                    minWidth={70}
                                                    noWrap={true}
                                                    title="% Reservado do período B - % Reservado do período A"
                                                    alignCenter
                                                    color="#FFF"
                                                    backgroundColor={
                                                        (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_b * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                            : 0) -
                                                            (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                                ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_a * 100) /
                                                                  totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                                : 0) >
                                                        0
                                                            ? "#43b85d"
                                                            : (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                                  ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_b * 100) /
                                                                    totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                                  : 0) -
                                                                  (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                                      ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_a * 100) /
                                                                        totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                                      : 0) <
                                                              0
                                                            ? "#ff3d56"
                                                            : "#005592"
                                                    }
                                                >
                                                    {(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                        ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_b * 100) /
                                                          totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                        : 0) -
                                                        (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_a * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                            : 0) >
                                                    0 ? (
                                                        <i className="fas fa-arrow-up" />
                                                    ) : (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                          ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_b * 100) /
                                                            totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                          : 0) -
                                                          (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                              ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_a * 100) /
                                                                totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                              : 0) <
                                                      0 ? (
                                                        <i className="fas fa-arrow-down" />
                                                    ) : null}
                                                    {Math.abs(
                                                        (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b > 0
                                                            ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_b * 100) /
                                                              totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_b
                                                            : 0) -
                                                            (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a > 0
                                                                ? (totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_a * 100) /
                                                                  totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_total_a
                                                                : 0)
                                                    )
                                                        .toFixed(2)
                                                        .replace(".", ",")}
                                                    {" %"}
                                                    <div style={{ fontSize: "0.6rem" }}>
                                                        {Math.abs(
                                                            totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_b -
                                                                totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_consumo_reservado_a
                                                        )
                                                            .toFixed(2)
                                                            .replace(".", ",")}
                                                        {" kWh"}
                                                    </div>
                                                </Td>
                                                <Td alignCenter color="#FFF" backgroundColor="#005592">
                                                    <div style={{ fontSize: "0.75rem" }}>
                                                        <div style={{ color: "#ff6e81", border: "1px solid #ff6e81", padding: 2 }}>
                                                            <div>
                                                                <b> Ponta</b>
                                                            </div>
                                                            {"R$ " + adicionarPontosMilhar(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_ponta)}
                                                        </div>
                                                        <div style={{ color: "#67f087", border: "1px solid #67f087", padding: 2 }}>
                                                            <div>
                                                                <b> Reservado</b>
                                                            </div>
                                                            {"R$ " + adicionarPontosMilhar(totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_reservado)}
                                                        </div>
                                                        <div
                                                            style={{
                                                                color:
                                                                    totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_ponta +
                                                                        totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_reservado >
                                                                    0
                                                                        ? "#43b85d"
                                                                        : totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_ponta +
                                                                              totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_reservado <
                                                                          0
                                                                        ? "#ff3d56"
                                                                        : "#FFF",
                                                                border: `1px solid ${
                                                                    totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_ponta +
                                                                        totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_reservado >
                                                                    0
                                                                        ? "#43b85d"
                                                                        : totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_ponta +
                                                                              totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_reservado <
                                                                          0
                                                                        ? "#ff3d56"
                                                                        : "#FFF"
                                                                }`,
                                                                padding: 2,
                                                            }}
                                                        >
                                                            <div>
                                                                <b> Total Resultante</b>
                                                            </div>
                                                            {"R$ " +
                                                                adicionarPontosMilhar(
                                                                    totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_ponta +
                                                                        totaisTabelaHorariosComparativoPeriodo.nao_irrigantes_retorno_financeiro_reservado
                                                                )}
                                                        </div>
                                                    </div>
                                                </Td>
                                            </Tr>
                                        ) : null}
                                    </>
                                </TBody>
                            </Table>
                        </Grid>
                    </Row>
                    <Row>
                        <Grid cols="12 4 4 4" style={{ display: "flex", flexDirection: "column" }}>
                            <div
                                className="callout callout-danger"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    flexGrow: 1,
                                    marginBottom: 10,
                                    color: "#000",
                                }}
                            >
                                <p>
                                    <strong style={{ color: "#bd2130" }}>Horário Ponta:</strong> Representa o custo mais elevado e tem duração de 3h por dia.
                                </p>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td
                                                colSpan="2"
                                                style={{
                                                    backgroundColor: "#fff59d",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "left",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                Orientações para Perfil de Consumo Ideal (valores aproximados dependendo de cada local).
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#c5e1a5",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Irrigações
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#dcedc8",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Próximo a 1%
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#a5d6a7",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Armazéns
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#c8e6c9",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Entre 10% e 20%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                        <Grid cols="12 4 4 4" style={{ display: "flex", flexDirection: "column" }}>
                            <div
                                className="callout callout-success"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    flexGrow: 1,
                                    marginBottom: 10,
                                    color: "#000",
                                }}
                            >
                                <p>
                                    <strong style={{ color: "#1e7e34" }}>Horário Fora Ponta:</strong> Representa um custo mediano e representa os horarios restantes do dia.
                                </p>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td
                                                colSpan="2"
                                                style={{
                                                    backgroundColor: "#fff59d",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "left",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                Orientações para Perfil de Consumo Ideal (valores aproximados dependendo de cada local).
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#c5e1a5",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Irrigações
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#dcedc8",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Próximo a 60%
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#a5d6a7",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Armazéns
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#c8e6c9",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Entre 80% e 90%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                        <Grid cols="12 4 4 4" style={{ display: "flex", flexDirection: "column" }}>
                            <div
                                className="callout callout-purple"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    flexGrow: 1,
                                    marginBottom: 10,
                                    color: "#000",
                                }}
                            >
                                <p>
                                    <strong style={{ color: "#7281bd" }}>Horário Reservado:</strong> Apenas em irrigação, representa o custo mais baixo do dia. Tem duração de 8,5h
                                    por dia (geralmente a noite, podento ter horários diferentes de acordo com contrato com a distribuidora de energia).
                                </p>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td
                                                colSpan="2"
                                                style={{
                                                    backgroundColor: "#fff59d",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "left",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                Orientações para Perfil de Consumo Ideal (valores aproximados dependendo de cada local).
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#c5e1a5",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Irrigações
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#dcedc8",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Próximo a 40%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                    </Row>
                </ContentCardBody>
            </ContentCard>
        </div>
    );

    function ExportAnalise({ listaGraficosDisponiveis }) {
        const [graficosAtivos, setGraficosAtivos] = useState(listaGraficosDisponiveis);
        const todosMarcados = graficosAtivos.length === listaGraficosDisponiveis.length;
        const existeAlgumMarcado = !!graficosAtivos.length;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) => setGraficosAtivos(todosMarcados ? [] : listaGraficosDisponiveis)}
                    value={todosMarcados}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficosPizzaCheckbox"
                    label="Custo, Consumo e Comparativo por Horário (Gráficos Pizza)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficosPizza") ? graficosAtivos.filter((grafico) => grafico !== "graficosPizza") : [...graficosAtivos, "graficosPizza"]
                        )
                    }
                    value={graficosAtivos.includes("graficosPizza")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoConsumoHorarioMensalCheckbox"
                    label="Consumo Mensal por Horário (kWh)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoConsumoHorarioMensal")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoConsumoHorarioMensal")
                                : [...graficosAtivos, "graficoConsumoHorarioMensal"]
                        )
                    }
                    value={graficosAtivos.includes("graficoConsumoHorarioMensal")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoConsumoPontaMensalCheckbox"
                    label="Consumo Ponta Mensal (kWh)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoConsumoPontaMensal")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoConsumoPontaMensal")
                                : [...graficosAtivos, "graficoConsumoPontaMensal"]
                        )
                    }
                    value={graficosAtivos.includes("graficoConsumoPontaMensal")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoConsumoForaPontaMensalCheckbox"
                    label="Consumo Fora Ponta Mensal (kWh)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoConsumoForaPontaMensal")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoConsumoForaPontaMensal")
                                : [...graficosAtivos, "graficoConsumoForaPontaMensal"]
                        )
                    }
                    value={graficosAtivos.includes("graficoConsumoForaPontaMensal")}
                />
                {!buscarPropriedadeUcFiltrada() || buscarPropriedadeUcFiltrada("irrigante") ? (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoConsumoReservadoMensalCheckbox"
                        label="Consumo Reservado Mensal (kWh)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoConsumoReservadoMensal")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoConsumoReservadoMensal")
                                    : [...graficosAtivos, "graficoConsumoReservadoMensal"]
                            )
                        }
                        value={graficosAtivos.includes("graficoConsumoReservadoMensal")}
                    />
                ) : null}
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="tabelaHorarioComparativoPeriodoCheckbox"
                    label="Aproveitamento Horário Comparativo Entre Períodos"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("tabelaHorarioComparativoPeriodo")
                                ? graficosAtivos.filter((grafico) => grafico !== "tabelaHorarioComparativoPeriodo")
                                : [...graficosAtivos, "tabelaHorarioComparativoPeriodo"]
                        )
                    }
                    value={graficosAtivos.includes("tabelaHorarioComparativoPeriodo")}
                />
                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={async (e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                await handleExport({ graficosAtivos, quantidadeUCs });
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => setModalExportacaoAberto(false)}
                        />
                    </Grid>
                </Row>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    filtro: state.analise.filtro,
    listaGraficoCustoDemandaEnergiaConsumida: state.analise.listaGraficoCustoDemandaEnergiaConsumida,
    listaGraficoConsumoReservado: state.analise.listaGraficoConsumoReservado,
    listaGraficoConsumoForaPonta: state.analise.listaGraficoConsumoForaPonta,
    listaGraficoConsumoPonta: state.analise.listaGraficoConsumoPonta,
    listaGraficoConsumoHorarioMensal: state.analise.listaGraficoConsumoHorarioMensal,
    listaGraficoCustoHorarioAnual: state.analise.listaGraficoCustoHorarioAnual,
    listaUnidadeConsumidora: state.analise.listaUnidadeConsumidora,
    listaGraficoConsumoHorarioAnual: state.analise.listaGraficoConsumoHorarioAnual,
    listaConsumoPercentualPorHorarioComparativoPeriodo: state.analise.listaConsumoPercentualPorHorarioComparativoPeriodo,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getListaGraficoCustoDemandaEnergiaConsumida,
            getListaGraficoConsumoReservado,
            getListaGraficoConsumoForaPonta,
            getListaGraficoConsumoPonta,
            getListaGraficoConsumoPorHorarioMensal,
            getListaGraficoConsumoPorHorarioAnual,
            getListaGraficoCustoPorHorarioAnual,
            getListaGeracaoComparativoConsumo,
            gerarRelatorio,
            setFiltro,
        },
        dispatch
    );
const AnaliseAproveitamentoConsumoHorario = connect(mapStateToProps, mapDispatchToProps)(analiseAproveitamentoConsumoHorario);
export { AnaliseAproveitamentoConsumoHorario };
